import { NumberBubble } from 'components/NumberBubble'
import { useRepository } from 'hooks/auth'
import { useCubitBuilder } from 'hooks/cubits'
import { useRootStore } from 'hooks/rootStore'
import { useTranslationTyped } from 'i18n/i18n'
import { InstructorAppealsCubit } from '@breakoutlearning/firebase-repository/cubits/InstructorAppealsCubit'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { usePendingAppealsCount } from './usePendingAppealsCount'

/**
 * Pending-appeal count for the nav item, summed across every section the
 * instructor reviews. This aggregate query is separate from the dashboard's
 * per-section queries; selecting the nav item explicitly refreshes it.
 */
export const NavAppealsBadge = observer(function NavAppealsBadge() {
  const repository = useRepository()
  const rootStore = useRootStore()
  const { tt } = useTranslationTyped()

  const cubit = useCubitBuilder(
    () =>
      new InstructorAppealsCubit(repository, {
        impersonationInfo: rootStore.impersonationInfo,
      }),
    [repository, rootStore.impersonationInfo]
  )

  const sections = cubit.reviewableSections
  const sectionIds = useMemo(
    () => (sections.isLoaded ? sections.value.map((s) => s.id) : []),
    [sections.isLoaded, sections.value]
  )

  const { total } = usePendingAppealsCount(sectionIds)

  if (total === 0) return null

  return (
    <NumberBubble
      count={total}
      srLabel={tt.instructor_appeals.pending_badge_label({
        count: total,
      })}
    />
  )
})
